module.exports = __webpack_public_path__ + "assets/img/hz2.d66a6bfc.png";